<template>
  <div>
    <comment-header
      :comment-count="opus.comment"
      :favor-count="opus.favor"
      :share-count="opus.share"
      :keep-count="opus.keep"/>
    <comment-list :comments="comments"/>
  </div>
</template>

<script>
  import CommentHeader from './cmt/CommentHeader'
  import CommentList from './cmt/CommentList'

  export default {
    name: 'OpusComment',
    props: {
      opus: Object,
      comments: Array
    },
    components: {
      CommentHeader,
      CommentList
    }
  }
</script>
